<template>
  <div style="height: calc(100% - 15px)">
    <div class="btn-group">
      <a-button
        v-acl="'page_ops_customer_program_transfer_upload'"
        type="primary"
        style="width: 108px; margin-right: 8px"
        :disabled="!fileId"
        @click="handleUpload"
      >
        {{ $t('page_ops_customer_upload') }}
      </a-button>
      <a-button
        v-acl="'page_ops_customer_program_transfer_download'"
        type="default"
        style="width: 108px; margin-right: 8px"
        :disabled="!fileId || selectedRowKeys.length===0"
        @click="handleDownload"
      >
        {{ $t('page_my_document_download') }}
      </a-button>
      <a-button
        v-if=deviceHasIssueFunction
        v-acl="'page_ops_customer_program_transfer_issue'"
        type="default"
        style="width: 108px; margin-right: 8px"
        :disabled="!fileId"
        @click="handleIssue"
      >
        {{ $t('page_ops_customer_program_transfer_issue_1') }}
      </a-button>
      <a-popconfirm
        :title="$t('page_transport_directory_sure_to_delete_the_file')"
        @confirm="handleDelete"
        :disabled="!fileId || selectedRowKeys.length===0"
        :okText="$t('ok')"
        :cancelText="$t('cancel')"
      >
        <a-button type="danger" v-acl="'page_ops_customer_program_transfer_delete'" style="width: 108px" :disabled="!fileId || selectedRowKeys.length===0">
          {{ $t('delete') }}
        </a-button>
      </a-popconfirm>
    </div>
    <div id="program-content-list" class="file-group" ref="programContent">
      <ml-table
        rowKey="id"
        :columns="columns"
        :data-source="dataSource"
        :customRow="customRow"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
       :scroll="{ y: `calc(100vh - 400px)` }"
      >
        <template slot="updateTime" slot-scope="updateTime, record">
          <span v-if="record.id">
            {{ updateTime | dayjs('YYYY-MM-DD HH:mm:ss') }}
          </span>
        </template>
      </ml-table>
    </div>
    <preview-modal
      :visible="previewVisible"
      :data="previewData"
      @close="closePreview"
    ></preview-modal>
    <upload :visible="uploadvisible" @closeUpload="closeUpload" :parentid="fileId"></upload>
  </div>
</template>

<script>
import PreviewModal from '../../../dnc/components/PreviewModal.vue'
import Upload from './Upload.vue'
import dayjs from 'dayjs'
import { downloadGET } from '@/api/api'
import { downloadFile } from '@/utils'
import { getLocalStorage } from '@/utils/storage'

import {
  TransferDirectoryFileQueryServiceProxy,
  TransferDirectoryFileServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'

import { TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { IotAppMethodServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'

const tdfsp = new TransferDirectoryFileServiceProxy()
const tdfqsp = new TransferDirectoryFileQueryServiceProxy()
const tssp = new TenantSettingServiceProxy()
const machineSrvProxy = new MachineServiceProxy();
const iamsp = new IotAppMethodServiceProxy()

export default {
  props: {
    device: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    PreviewModal,
    Upload
  },
  watch: {
    device: {
      handler(val) {
        this.dataSource = [];
        this.selectedRowKeys = [];
        if (!val.id) {
          return
        }
        this.getStationData()
        this.getDeviceIsHasIssueFunction()
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      customRow: (record) => {
        return {
          on: {
            click: (e) => {
              this.clickRow(record)
            }
          }
        }
      },
      dataSource: [],
      previewData: {},
      previewVisible: false,
      timer: null,
      uploadvisible: false,
      record: {},
      fileId: '',
      deviceHasIssueFunction: false,
      execMethodParam: {},
      selectedRowKeys: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('actions'),
          dataIndex: 'actions',
          key: 'actions',
          customRender: (_, record) => {
            return (
              <div>
                <a
                  onClick={(e) => {
                    e.stopPropagation()
                    this.handlePreview(record)
                  }}
                >
                  {this.$t('preview')}
                </a>
              </div>
            )
          }
        },
        {
          title: this.$t('page_my_document_filename'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: this.$t('page_work_data_source'),
          dataIndex: 'fileSource',
          key: 'fileSource',
          customRender: (text) => {
            // file_source:  本地上传 1：非资源 2：资源 4：NC同步
            const fileSourceMap = { 0: 'page_transport_directory_upload', 1: 'page_non_resource', 2: 'page_resource', 4: 'page_nc' }
            return this.$t(fileSourceMap[text])
          }
        },
        {
          title: this.$t('page_work_record_type'),
          dataIndex: 'suffix',
          key: 'suffix'
        },
        {
          title: this.$t('page_update_time'),
          key: 'updateTime',
          dataIndex: 'updateTime',
          width: 170,
          customRender: (text) => {
            return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      ]
    }
  },
  created() {
    this.dataSource = []
    if (!this.device.id) {
      return
    }
    this.getStationData()
    this.getDeviceIsHasIssueFunction()
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    async getDeviceIsHasIssueFunction(){
      this.deviceHasIssueFunction = false
      this.execMethodParam = {}
      let res = await machineSrvProxy.getMachineGateway(this.device.id)
      if(res.methodList){
        let method = res.methodList.find((i) => i.methodName == 'MC_ManualDistributionFile')
        if(method){
          this.deviceHasIssueFunction = true
          this.execMethodParam = {appCode:res.iotAppCode,gatewayCode:res.gatewayCode,methodId:method.methodId}
        }
      }
    },
    handleUpload() {
      this.uploadvisible = true
    },
    closeUpload(value) {
      if (value) {
        this.awaitData()
      }
      this.uploadvisible = false
    },
    clickRow(record) {
      this.record = record
    },
    handleDelete() {
      tdfsp.deleteBatchFile(this.selectedRowKeys).then(_=>{
        this.$message.success(this.$t('page_transport_directory_file_deleted_successfully'))
        this.selectedRowKeys = [];
        this.awaitData()
      })
    },
    handleDownload() {
      for(let i = 0; i<this.selectedRowKeys.length; i++) {
        const selectedItemId = this.selectedRowKeys[i];
        for(let j = 0; j<this.dataSource.length; j++) {
          const dataItem = this.dataSource[j]
          if(selectedItemId === dataItem.id) {
            const { objectKey, contentType, name } = dataItem;
            downloadGET(objectKey, objectKey, contentType).then(res => {
              downloadFile(res, name)
            })
          }
        }
      }
    },
    async handleIssue() {
      let params = {
        appCode: this.execMethodParam.appCode,
        execParamMap: {},
        gatewayCode: this.execMethodParam.gatewayCode,
        isAsync: true,
        methodId: this.execMethodParam.methodId
      }
      let res = await iamsp.execMethod(params)
      if (res && res.message && res.message !== 'null') {
          try {
            let str = JSON.parse(res.message)
            if (str.hasOwnProperty('responseCode')) {
              this.message = str.responseCode === 0 ? this.$message.success(this.$t('page_log_management_status_0')) :
              this.$message.error(str.message)
            } else {
              this.$message.error(str.message)
            }
          }catch (e) {
            this.$message.error(res.message)
          }
        }
    },
    handlePreview(record) {
      this.previewData = record
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
    },
    async getStationData() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.fileId = ''
        const user = getLocalStorage('USER_INFO')
        const tenantId = user.tenant_id
        tssp.getTenantSetting(this.device.id, 'workStation-transfer', tenantId).then((res) => {
          this.fileId = res.paramValue
          this.awaitData()
        })
      }, 50)
    },
    async awaitData() {
      if (!this.fileId) {
        return
      }
      this.record = {}
      this.dataSource = []
      const data = await tdfqsp.fileList('', this.fileId)
      if (data && data.length) {
        const source = data.map((res) => {
          res['name'] = res.originalFilename
          return res
        })
        this.dataSource = source.filter((res) => res.fileType == 1)
      }
      this.getScroll(this.dataSource)
    },
    getScroll(programList) {
      const programDiv = document.getElementById('program-content-list')
      if (programDiv) {
        const pheight = programList.length * 33
        if (pheight > programDiv.clientHeight - 48) {
          this.programScrollY = programDiv.clientHeight - 50
        } else {
          this.programScrollY = 0
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.file-group {
  height: calc(100% - 60px);
  margin-top: 8px;
  border: 1px solid #d8d8d8;
}
</style>
